import { render, staticRenderFns } from "./PopupCreate.vue?vue&type=template&id=3bdf5748&"
import script from "./PopupCreate.vue?vue&type=script&lang=js&"
export * from "./PopupCreate.vue?vue&type=script&lang=js&"
import style0 from "./PopupCreate.vue?vue&type=style&index=0&id=3bdf5748&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports